export default __webpack_public_path__ + "static/scfxy_hover-796db197b13a167d2330eed5ca10680e.png";